import { api } from "./api";

export const customerTypesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerTypes: builder.query({
      query: () => "api/Sales/CustomerTypes",
      providesTags: ["customerTypes"],
    }),
    addCustomerType: builder.mutation({
      query: (formData) => ({
        url: "api/Sales/CustomerTypes",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["customerTypes"],
    }),
    editCustomerType: builder.mutation({
      query: (formData) => ({
        url: "api/Sales/CustomerTypes",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["customerTypes"],
    }),
    deleteCustomerType: builder.mutation({
      query: (typeId) => ({
        url: `api/Sales/CustomerTypes?CustTypeID=${typeId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["customerTypes"],
    }),
  }),
});

export const {
  useGetCustomerTypesQuery,
  useAddCustomerTypeMutation,
  useEditCustomerTypeMutation,
  useDeleteCustomerTypeMutation,
} = customerTypesApi;
